import React from 'react'
import { walletUrl } from '@/urls'
import { useNavigate } from 'react-router-dom'
import CurrencyIcon from '@/components/currencyIcon'
import { i18n } from '@/locale/i18n'

const Deposit = ({ currency }) => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-4" onClick={() => navigate(walletUrl())}>
      {currency && <CurrencyIcon currency={currency} width="48px" />}

      <div className="flex items-center gap-1">
        <div>{i18n('cash_in.deposit_succeeded')}</div>
      </div>
    </div>
  )
}

export default Deposit
